import { createAction, props } from '@ngrx/store';
import { IUpdateBankRequest, IUpdateBankResponse } from '../models/employee-bank-detail.model';

export const updateBank = createAction(
  '[Bank] Update Bank',
  props<{ request: IUpdateBankRequest }>()
);

export const updateBankSuccess = createAction(
  '[Bank] Update Bank Success',
  props<{ response: IUpdateBankResponse }>()
);

export const updateBankFailure = createAction(
  '[Bank] Update Bank Failure',
  props<{ error: any }>()
);